import React, { useEffect, useState } from "react";
import * as cls from "./contractPaymentDebt.module.scss";
import Download from "../../resources/icons/Download";
import Paying from "../../resources/icons/Paying";
import Payments from "../../resources/icons/Payments";
import { useSelector } from "react-redux";
import { StudentService } from "../studentService";
import { ErrataViewInfo } from "../../../personal-studio-components/service/ErrataViewInfo";
import {
  ErrataView,
  ErrataWidget,
  WidgetFrame,
} from "../../../personal-studio-components/studio";
import { useNavigate } from "react-router-dom";

export default function ContractPaymentDebt({ menu, hasPaymentBtn }) {
  const { access_token } = useSelector((state) => state.token);
  const { contractId } = useSelector((state) => state.contract);
  const [data, setData] = useState(null);
  const [errorMessage, setErrorMessage] = useState(null);
  async function getContractPaymentDebt() {
    if (access_token) {
      const request = {
        method: "post",
        path: "/student/widget/contract_payment_debt",
        data: {
          access_token,
          study_contract_id: contractId,
          return_row_value: 0,
        },
      };

      await StudentService.send(request, (response) => {
        if (response) {
          setErrorMessage(response);
          if (!response.errors) {
            setData(response.debt);
          } else {
            const errorEvent = new ErrorEvent("error", {
              error: response,
            });
            window.dispatchEvent(errorEvent);
            return;
          }
        }
      });
    }
  }
  async function getFinancialDossier() {
    if (access_token) {
      const request = {
        method: "post",
        path: "/student/payment/financial_dossier",
        data: {
          access_token,
          study_contract_id: contractId,
        },
      };
      await StudentService.send(request, (response) => {
        if (response) {
          setErrorMessage(response);
          if (!response.errors) {
            window.open(response.financial_dossier_url, "_blank");
          }
        }
      });
    }
  }
  const navigate = useNavigate();
  const handleNavigate = () => {
    navigate("/payment");
  };
  useEffect(() => {
    getContractPaymentDebt();
  }, [contractId]);
  if (errorMessage && errorMessage.errors) {
    return (
      <WidgetFrame title="Ваш баланс" icon="balance">
        {errorMessage.error_type === "info" ? (
          <ErrataViewInfo errata={errorMessage} />
        ) : (
          <ErrataView errata={errorMessage} />
        )}
      </WidgetFrame>
    );
  }
  return (
    <WidgetFrame
      title="Ваш баланс"
      menu={menu}
      type="primary"
      icon="balance"
      className={cls.your_balance_container}
    >
      {/* <div className={cls.your_balance_container}> */}
      {/* <div className={cls.your_balance_title_wrapper}>
        <div className={cls.your_balance_avatar_wrapper}>
          <div className={cls.your_balance_avatar}>
            <Payments />
          </div>
          <div className={cls.your_balance_title}>Ваш баланс</div>
        </div>
        <div className={cls.your_balance_btn_settings}>
          <div className={cls.your_balance_btn_settings_info}>...</div>
        </div>
      </div> */}

      <div className={cls.debt}>
        {data > 0 || data < 0 ? data : "Задолженность отсутствует"}
      </div>
      <div className={cls.btn_debt_balance_wrapper}>
        <div>
          <button className={cls.extract} onClick={getFinancialDossier}>
            Выписка{" "}
            <span className={cls.extract_icon}>
              <Download />
            </span>
          </button>
        </div>
        {hasPaymentBtn && (
          <div>
            <button onClick={handleNavigate} className={cls.replenish}>
              Пополнить{" "}
              <span className={cls.replenish_icon}>
                <Paying />
              </span>
            </button>
          </div>
        )}
      </div>

      {/* </div> */}
    </WidgetFrame>
  );
}
